import React, { useEffect, useState } from 'react';
import { bool, func, object, node } from 'prop-types';

import Box from '../atoms/Box';
import Separator from '../atoms/Separator';

import Plus from '../atoms/icons/Plus.js';
import Minus from '../atoms/icons/Minus.js';

const ExpandablePanel = ({ title, children, schemaTitle = {}, schemaChildren = {}, expanded = false, callback }) => {
  const [isExpanded, toggleExpanded] = useState(expanded);

  const expandOrCollapse = () => {
    toggleExpanded(!isExpanded);
    callback(!isExpanded);
  };

  useEffect(() => {
    toggleExpanded(expanded);
  }, [expanded]);

  return (
    <div {...schemaTitle}>
      <Box
        style={{ cursor: 'pointer' }}
        display="flex"
        justifyContent="space-between"
        mb={2}
        onClick={expandOrCollapse}>
        {title}
        {isExpanded ? <Minus fontSize="24px" color="dark" /> : <Plus fontSize="24px" color="dark" />}
      </Box>
      <Box display={isExpanded ? 'block': 'none'} pr={6} {...schemaChildren}>
        {children}
      </Box>
      <Separator />
    </div>
  );
};

ExpandablePanel.propTypes = {
  title: object,
  children: node,
  schemaTitle: object,
  schemaChildren: object,
  expanded: bool,
  callback: func
};

ExpandablePanel.defaultProps = {
  callback: () => null
};

export default ExpandablePanel;
